import PointingRobotSvg from '@/assets/PointingRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import { useGetQuizDefinition } from '@/hooks/useGetQuizDefinition.util.ts';
import { useGetQuizIdentifiers } from '@/hooks/useGetQuizIdentifiers.ts';
import { useInitializeQuiz } from '@/hooks/useInitializeQuiz.ts';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

const InitializeQuizPage: React.FC = () => {
  const isMobile = useMobileMediaQuery();
  const { t } = useTranslationWithPrefix('startGamePage');
  const { isGettingQuizIdentifier, quizIdentifier } = useGetQuizIdentifiers();
  const { initializeQuiz, isInitializing } = useInitializeQuiz();
  const { isGetting, quizDefinition } = useGetQuizDefinition(quizIdentifier?.quizId);

  const handleStartGame = async (e: React.FormEvent) => {
    e.preventDefault();
    await initializeQuiz(quizIdentifier?.quizId);
  };
  const isLoading = isInitializing || isGettingQuizIdentifier || isGetting;
  return (
    <div className="mt-10 flex gap-8 lg:flex-row pb-2">
      <div className="flex flex-col gap-l z-1 md:w-[550px]">
        <p className="display-2 text-primary">{t('heading')}</p>
        <ul className="m-0 info-list">
          {[
            t('list.listItem1', {
              timeToCompleteInMinutes: quizDefinition?.timeToCompleteInMinutes,
            }),
            t('list.listItem2'),
            t('list.listItem3'),
            t('list.listItem4'),
            t('list.listItem5'),
            t('list.listItem6'),
            t('list.listItem7'),
            t('list.listItem8'),
          ].map(item => (
            <li className="lead flex" key={item}>
              <div className="li-marker bg-primary" />
              <div className="flex-1">{item}</div>
            </li>
          ))}
        </ul>
        {isMobile && (
          <div className="flex-1">
            <img
              alt="start-game"
              className="w-100 object-cover"
              src={generateNonCachableImageSrc(PointingRobotSvg)}
            />
          </div>
        )}
        <ButtonWithLoading isLoading={isLoading} onClick={handleStartGame}>
          {t('buttons.startGame')}
        </ButtonWithLoading>
      </div>
      {!isMobile && (
        <div className="-mt-20">
          <img
            alt="pointing-robot"
            className="w-full"
            src={generateNonCachableImageSrc(PointingRobotSvg)}
          />
        </div>
      )}
    </div>
  );
};

export default InitializeQuizPage;
